import { captureException } from "@eroad/monitoring/sentry";

import { IS_TEST_RUN } from "../constants";

/**
 * An adaptor for whatever third party library we want to use to report production errors.
 *
 * Consider using something else like invariant if you are only looking to notify of development level inconsistencies -
 * this doesn't spam our error reporting services and is more likely to be seen in dev where it can be addressed.
 *
 * @param {unknown} e - the error to report
 */
const reportError = (e: $TSFixMe, context = {}, environment = process.env.REACT_APP_ENVIRONMENT) => {
  if (!IS_TEST_RUN && e instanceof Error && environment !== "local") {
    // manual report to sentry - always with manuallyReported tag to true
    captureException(e, {
      ...context,
      tags: {
        ...(context as $TSFixMe).tags,
        manuallyReported: "true",
      },
    });
  } else {
    console.error(e, context);
  }
};

export { reportError };
